import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";
import GoogleSignInButton from "../components/GoogleSignInButton";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#E63946] mb-3">Members</div>
      <h1 className="font-serif font-black text-4xl md:text-5xl tracking-tighter mb-8">Log in</h1>
      <GoogleSignInButton label="Continue with Google" testId="google-signin-login" />
      <div className="flex items-center gap-3 my-6" aria-hidden="true">
        <div className="flex-1 h-px bg-black/10" />
        <span className="text-[10px] font-mono uppercase tracking-widest text-black/40">or with email</span>
        <div className="flex-1 h-px bg-black/10" />
      </div>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs font-bold uppercase tracking-widest block mb-2">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-black px-4 py-3 focus:outline-none focus:bg-black focus:text-white"
            data-testid="login-email"
          />
        </div>
        <div>
          <label className="text-xs font-bold uppercase tracking-widest block mb-2">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-black px-4 py-3 focus:outline-none focus:bg-black focus:text-white"
            data-testid="login-password"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-black text-white px-6 py-3 font-bold uppercase tracking-widest text-xs hover:bg-[#E63946] disabled:opacity-50"
          data-testid="login-submit"
        >
          {loading ? "…" : "Log in"}
        </button>
      </form>
      <p className="text-sm text-black/60 mt-6">
        No account?{" "}
        <Link to="/register" className="underline hover:text-[#E63946]" data-testid="to-register">Create one</Link>
      </p>
    </div>
  );
}
